import {
  BULK_PROCESS_SUCCESS,
  CLEAR_PRE_VERIFICATION_APPROVAL_STATE_DATA,
  CLEAR_PRE_VERIFICATION_APPROVAL_STATE_SUCCESS,
  CREATE_PRE_VERIFICATION_APPROVAL_SUCCESS,
  FETCH_PRE_VERIFICATION_APPROVAL_SUCCESS,
  GET_PRE_VERIFICATION_APPROVAL_SUCCESS,
  PRE_VERIFICATION_UPLOAD_COUNT_DECREASE,
  PRE_VERIFICATION_UPLOAD_COUNT_INCREASE,
  SAVE_PRE_VERIFICATION_APPROVAL_QUERY,
  SAVE_PRE_VERIFICATION_APPROVAL_STATE_SUCCESS,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  preApprovalResources: [],
  resource: {},
  edit: {},
  query: {},
  initialRecord: {},
  astUploadCount: 1,
  warning: {},
  bulkProcessJob: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_PRE_VERIFICATION_APPROVAL_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_PRE_VERIFICATION_APPROVAL_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;
      return {
        ...state,
        query: query,
        preApprovalResources: action.data,
        total: action.total,
      }
    }

    case CREATE_PRE_VERIFICATION_APPROVAL_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }


    case FETCH_PRE_VERIFICATION_APPROVAL_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    case CLEAR_PRE_VERIFICATION_APPROVAL_STATE_SUCCESS: {
      return {
        ...state,
        resource: {},
      }
    }

    case CLEAR_PRE_VERIFICATION_APPROVAL_STATE_DATA: {
      return {
        ...state,
        resource: {},
        record: {},
        edit: {},
        astUploadCount: 1
      }
    }

    case SAVE_PRE_VERIFICATION_APPROVAL_STATE_SUCCESS: {
      return {
        ...state,
        record: action.data,
      }
    }

    case BULK_PROCESS_SUCCESS: {
      return {
        ...state,
        bulkProcessJob: action.data,
      }
    }

    case PRE_VERIFICATION_UPLOAD_COUNT_INCREASE: {
      return {...state, astUploadCount: state.astUploadCount + 1};
    }

    case PRE_VERIFICATION_UPLOAD_COUNT_DECREASE: {
      return {...state, astUploadCount: state.astUploadCount - 1};
    }


    default:
      return state;
  }
}
